/**
 * 题目生成器注册表
 * ------------------------------------------------------------
 * 每个生成器负责：给定单元内容 → 产出标准题目对象（结构见 core/models.js makeQuestion）。
 * 新增一种练习方式/题型 = 新建一个生成器文件并注册，不改引擎与会话逻辑。
 *
 * 生成器接口：
 *   registerGenerator({
 *     id, module: 'word'|'sentence'|'grammar'|'custom',
 *     levels: [{ level, name, icon, desc, skill }],   // 可选，供 UI 渲染层级选择
 *     build({ content, level, count, priority, options }) -> question[]
 *   })
 */
const registry = new Map();

export function registerGenerator(gen) {
  if (!gen?.id || typeof gen.build !== 'function') {
    throw new Error('[generators] 注册失败：需要 id 与 build()');
  }
  registry.set(gen.id, gen);
  return gen;
}

export const generatorRegistry = {
  get: id => registry.get(id) || null,
  all: () => [...registry.values()],
  byModule: module => [...registry.values()].filter(g => g.module === module),
  has: id => registry.has(id),
};
